import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import { useData } from "../../../components/firebase/DataProvider";
import {
  analytics,
  FieldValue,
} from "../../../components/firebase/FirebaseProvider";
import { useSnackbar } from "notistack";
import Gap from "../../../components/atoms/Gap";
import Header from "../../../components/molecules/Header";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  arrayToCurrencyStringKomisi,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { CopyToClipboard } from "react-copy-to-clipboard";
import slugify from "slugify";
import { upperFirst } from "lodash";
import useStyles from "./style";

const CardProduct = ({
  item,
  index,
  toDetailProduct,
  promoF,
  emptyStock,
  textBadgePromo,
  total_stok,
  productValue,
  harga_normal,
  promoFound,
  harga_str_promo,
  harga_str,
  domain,
  // bagikan,
}) => {
  const classes = useStyles();
  const { level, promo, global_komisi } = useData();

  const [newArrival, setNewArrival] = useState(false);

  useEffect(() => {
    const time = new Date();
    const timeSeconds = Math.round(time.getTime() / 1000);
    const timeNewArrival = item?.new_arrival?.seconds;
    const expiredTime = timeNewArrival - timeSeconds;
    if (expiredTime > 0) {
      setNewArrival(true);
    } else {
      setNewArrival(false);
    }
  }, []);

  const lowestPrice = Math.round(Math.min(...harga_normal));

  const all_komisi_str = arrayToCurrencyStringKomisi(
    lowestPrice,
    level.level,
    promoFound,
    global_komisi,
    productValue
  );

  return (
    <div className={classes.wrapper} key={index}>
      <Card className={classes.card}>
        <CardActionArea onClick={toDetailProduct(item.id, item.nama)}>
          {promoF && !emptyStock ? (
            <div className={classes.label}>
              <Typography className={classes.txtLabel}>
                {textBadgePromo}
              </Typography>
              <Typography className={classes.txtLabel}>OFF</Typography>
            </div>
          ) : null}

          {emptyStock ? (
            <div className={classes.empty}>
              <span className={classes.txtEmpty}>Stok Habis</span>
            </div>
          ) : null}
          {item.thumbnail?.length > 0 ? (
            <div
              loading="lazy"
              // src={item.thumbnail[0]}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item.thumbnail[0]})`,
              }}
            />
          ) : (
            <div
              loading="lazy"
              // src={item.thumbnail}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item.thumbnail})`,
              }}
            />
          )}
        </CardActionArea>
        <div className={classes.contentWrapper}>
          <div
            className={classes.content}
            onClick={toDetailProduct(item.id, item.nama)}
          >
            <div style={{ display: "flex", marginBottom: 5 }}>
              {promoFound?.flash_sale || promoFound?.special_offer ? (
                <div className={classes.labelFlash}>
                  {promoFound?.flash_sale ? "Flashsale" : "Special Offer"}
                </div>
              ) : null}
              {item?.properties?.type === "preorder" && (
                <div className={classes.labelPre}>Pre Order</div>
              )}
              {newArrival && <div className={classes.labelNew}>Baru</div>}
            </div>
            <Typography className={classes.title} noWrap component="p">
              {item?.nama}
            </Typography>
            <div>
              {item?.properties?.type === "preorder" ? (
                ""
              ) : (
                <>
                  <Typography
                    className={classes.txtStockTersedia}
                    component="p"
                  >
                    Stok tersedia
                  </Typography>
                  <Typography className={classes.txtStock} component="p">
                    {total_stok > 100 ? "99+" : total_stok} pcs
                  </Typography>
                </>
              )}
            </div>
            <div>
              <Typography className={classes.txtLabelharhag} component="p">
                Harga {upperFirst(level.level)}
              </Typography>
              {promo && (
                <Typography className={classes.price} component="p">
                  {promoFound ? harga_str_promo : harga_str}
                </Typography>
              )}
            </div>
            <div className={classes.labelKomisi}>
              {all_komisi_str} Komisi
            </div>
            {/* {newArrival && (
              <div style={{ position: "absolute", right: 0, zIndex: "0" }}>
                <NewFeatureIcon width={32} height={32} />
              </div>
            )} */}
          </div>
          <div className={classes.btnWrap}>
            {emptyStock ? (
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size="small"
                className={classes.btn}
                style={{
                  backgroundColor: "rgb(255, 107, 107)",
                }}
              >
                Stok Habis
              </Button>
            ) : (
              <CopyToClipboard
                text={`${domain}/produk/${slugify(item.nama.toLowerCase())}/${
                  item.product_id
                }`}
                // onCopy={bagikan(item)}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.btn}
                  // endIcon={<ShareIcon />}
                >
                  Bagikan Produk
                </Button>
              </CopyToClipboard>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

function CollectionDetails() {
  const {
    collectionProduct,
    level,
    promo,
    global_komisi,
    webstore,
    webstoreRef,
    preorderUtils
  } = useData();
  const { id } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const [copied, setCopied] = useState(true);
  const data = collectionProduct[id];
  const { enqueueSnackbar } = useSnackbar();
  const toDetailProduct = (id, title) => () => {
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };
  const domain = `https://${webstore.domain}.tokorame.store`;

  const bagikan = (data) => async () => {
    setCopied(true);
    const findProductId = webstore.products?.includes?.(data.id);
    const checkDownpayment = preorderUtils?.down_payment_products?.includes(data.id);
    const downPaymentStatus = checkDownpayment && preorderUtils?.down_payment_option;

    if (!findProductId && !downPaymentStatus) {
      await webstoreRef.set(
        {
          products: FieldValue.arrayUnion(data.id),
        },
        { merge: true }
      );
    }

    enqueueSnackbar("Link di salin", { variant: "success" });
  };

  return (
    <>
      <Header title={"Koleksi Tokorame"} type="with-search-cart" />
      <Gap height={55} />
      <div style={{padding:20}}>
        <img className={classes.hero} src={data.banner_image} alt="hero" />
      </div>
      <div style={{ margin: 20 }}>
        <div
          className={classes.labelTitle}
          style={{ backgroundColor: data.color }}
        >
          {data.name}
        </div>
      </div>
      <Grid container className={classes.root}>
        {data?.products?.map((item, index) => {
          const stok = item.variants.map((variant) => variant.stok_available);

          const productValue =
            item?.product_value !== undefined &&
            item?.product_value !== "" &&
            !Number.isNaN(item?.product_value) &&
            item?.product_value >= 0
              ? item?.product_value
              : 1;

          const harga = item.variants.map((variant) =>
            calculateHargaLevel(
              variant?.harga_normal,
              global_komisi,
              level?.level,
              productValue
            )
          );

          const harga_normal = item.variants.map(
            (variant) => variant?.harga_normal
          );

          const promoFound = findOnePromo(item, promo);

          const total_stok = stok.reduce((val, nilaiSekarang) => {
            return val + nilaiSekarang;
          }, 0);

          const emptyStock = total_stok === 0 ? true : false;

          const harga_str = arrayToCurrencyString(harga);
          const promoF = promoFound ? true : false;

          const harga_str_promo =
            promoFound &&
            arrayToCurrencyStringPromo(
              harga_normal,
              promoFound,
              level.level,
              global_komisi,
              productValue
            );

          const textBadgePromo = (() => {
            let text = "";

            if (promoFound) {
              if (promoFound?.tipe === "%") {
                text = `${promoFound?.nilai}%`;
              } else {
                text = `${promoFound?.nilai / 1000}K`;
              }
            }

            return text;
          })();
          return (
            <CardProduct
              item={item}
              index={index}
              toDetailProduct={toDetailProduct}
              textBadgePromo={textBadgePromo}
              productValue={productValue}
              harga_normal={harga_normal}
              bagikan={bagikan}
              promoFound={promoFound}
              promoF={promoF}
              harga_str_promo={harga_str_promo}
              harga_str={harga_str}
              domain={domain}
              total_stok={total_stok}
              emptyStock={emptyStock}
            />
          );
        })}
      </Grid>
    </>
  );
}

export default CollectionDetails;
